import { useMemo, useRef } from "react";
import * as meshline from "threejs-meshline";
import { extend, Canvas, useFrame, useThree } from "react-three-fiber";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { Curves } from "three/examples/jsm/curves/CurveExtras";

import "./styles.css";

extend(meshline);
extend({ OrbitControls });

const Controls = () => {
  const orbitRef = useRef();
  const { camera, gl } = useThree();

  useFrame(() => {
    orbitRef.current.update();
  });
  return (
    <orbitControls
      args={[camera, gl.domElement]}
      ref={orbitRef}
      enablePan={false}
    />
  );
};

function Fatline({ curve, width, color, speed }) {
  const material = useRef();
  const mesh = useRef();
  useFrame(() => {
    material.current.uniforms.dashOffset.value -= speed;
    mesh.current.rotation.x += 0.002;
    mesh.current.rotation.y += 0.005;
  });
  return (
    <mesh ref={mesh} rotation={[1, Math.random() * 5, 0]}>
      <meshLine attach="geometry" vertices={curve} />
      <meshLineMaterial
        attach="material"
        ref={material}
        transparent
        depthTest={false}
        lineWidth={width}
        color={color}
        dashArray={0.01}
        dashRatio={0.92}
      />
    </mesh>
  );
}

const count = 300;

function Lines({ count, colors }) {
  const lines = useMemo(
    () =>
      new Array(count).fill().map(() => {
        const curve = new Curves.TrefoilKnot(30).getPoints(100);

        return {
          color: colors[parseInt(colors.length * Math.random())],
          width: 0.2,
          speed: Math.max(0.0001, 0.0004 * Math.random()),
          curve,
        };
      }),
    [colors, count],
  );
  return lines.map((props, index) => <Fatline key={index} {...props} />);
}

export default function MeshLineComponent() {
  return (
    <div className="App">
      <Canvas camera={{ position: [10, 10, 200], fov: 70 }}>
        <Controls />
        <Lines
          count={count}
          colors={[
            "#ff6633",
            "#FFB399",
            "#FF33FF",
            "#FFFF99",
            "#00B3E6",
            "#E6B333",
            "#3366E6",
            "#99FF99",
            "#80B300",
            "#6680B3",
            "#66991A",
            "#FF99E6",
            "#CCFF1A",
            "#FF1A66",
            "#E6331A",
            "#33FFCC",
            "#66994D",
            "#B366CC",
            "#4D8000",
            "#B33300",
            "#CC80CC",
            "#991AFF",
            "#E666FF",
            "#4DB3FF",
            "#1AB399",
            "#E666B3",
            "#00d768",
            "#e1ff6b",
            "#1AFF33",
            "#FF3380",
            "#CCCC00",
            "#4D80CC",
            "#9900B3",
            "#E64D66",
            "#4DB380",
            "#FF4D4D",
            "#99E6E6",
            "#6666FF",
          ]}
        />
      </Canvas>
    </div>
  );
}
